<div *ngIf="shouldShowErrors()">
    <div class="w-100" *ngFor="let error of listOfErrors()">
        <span class="error err-{{ detail.name || 'control' }} text-danger">{{ error | translate }}</span>
    </div>
</div>